module.exports = __webpack_public_path__ + "img/first_wave_bottom.3ef8eba2.svg";